// src/services/authService.js
const TOKEN_KEY = "access_token";
const USER_KEY = "user";

export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

export const setUser = (user) => localStorage.setItem(USER_KEY, JSON.stringify(user));
export const getUser = () => JSON.parse(localStorage.getItem(USER_KEY));
export const removeUser = () => localStorage.removeItem(USER_KEY);

export const logout = () => {
  removeToken();
  removeUser();
};
